import React, { useEffect } from 'react';
import { IPromotionMessage, PROMOTIONS_MSG_FEE_BASED, PROMOTIONS_MSG_FX_BASED } from './util';
import { DiscountAppliedTag, DiscountContainer, MessageContainer } from './style';
import { useDispatch, useSelector } from 'react-redux';
import { getCountryCode, selectTransactionReducer } from '@Redux/selectors';
import { FEE_BASED_MARKETS, HIGH_VALUE_TRANSACTION } from '@Utils/constants';
import { isFlagEnabled } from '@Redux/actions/flagsmith';
import { compileTemplateNew } from '@Utils/library';
import { getContentSchemaFromContentFul } from '@Redux/actions/common';
import { AppDispatch } from '../../store.type';
import { savePromotionsCMSData } from '@Redux/actions/transaction/transaction-action';
import { isEmpty } from 'lodash';

export const PromotionMessage: React.FC<IPromotionMessage> = (props) => {
  const {
    marginBottom,
    rightMargin,
    firstTimeTransfer,
    discountTagTopMargin,
    discountTagFlexStartAlignment,
    isNthTransactionApplicable,
    hvtThresholdLimit,
    sourceCurrency,
    grossSourceAmount,
    upsellOfferDiscountId,
    isDiscountApplied,
    tier
  } = props;
  const countryCode = useSelector(getCountryCode);
  const dispatch = useDispatch<AppDispatch>();
  const transactionReducer = useSelector(selectTransactionReducer);
  const { promotionsCMSData } = transactionReducer || {};
  const userNotInDefaultTierAndDiscountApplied = !(
    tier?.includes('DEFAULT_HIGH_VALUE') && isDiscountApplied
  );

  const fetchCmsData = async () => {
    if (!isEmpty(promotionsCMSData)) return;
    const response = await getContentSchemaFromContentFul('component', 'OFFER_PROMOTION_WEB');
    if (response?.labels?.value) {
      dispatch(savePromotionsCMSData(response.labels.value));
    }
  };

  useEffect(() => {
    fetchCmsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isFeeBasedMarket = FEE_BASED_MARKETS.includes(countryCode);

  const PROMOTIONS_MSG = isFeeBasedMarket
    ? promotionsCMSData?.FEE_BASED || PROMOTIONS_MSG_FEE_BASED
    : promotionsCMSData?.FX_BASED || PROMOTIONS_MSG_FX_BASED;
  let discountAppliedTag = true;
  let selectedPromotion;
  if (firstTimeTransfer && isDiscountApplied) {
    selectedPromotion = PROMOTIONS_MSG['FTT'];
  } else if (isNthTransactionApplicable && isDiscountApplied) {
    selectedPromotion = PROMOTIONS_MSG['NTh'];
  } else if (
    isFlagEnabled(HIGH_VALUE_TRANSACTION) &&
    grossSourceAmount >= hvtThresholdLimit?.thresholdLimit &&
    isDiscountApplied
  ) {
    selectedPromotion = PROMOTIONS_MSG['HVT'].discountAppliedMsg;
  } else if (upsellOfferDiscountId && isDiscountApplied) {
    selectedPromotion = PROMOTIONS_MSG['UPSELL'];
  } else if (
    //Since this will be always applicable before upsell, but need to show on non applied upsell discount scenarios.
    isFlagEnabled(HIGH_VALUE_TRANSACTION) &&
    userNotInDefaultTierAndDiscountApplied &&
    grossSourceAmount < hvtThresholdLimit?.thresholdLimit
  ) {
    discountAppliedTag = false;
    selectedPromotion = PROMOTIONS_MSG['HVT'].discountMsg;
  }

  if (!selectedPromotion) return null;
  return (
    <>
      <DiscountContainer $flexStart={discountTagFlexStartAlignment}>
        {discountAppliedTag && (
          <DiscountAppliedTag $marginTop={discountTagTopMargin}>
            Discount applied
          </DiscountAppliedTag>
        )}
      </DiscountContainer>
      <MessageContainer $marginBottom={marginBottom} $rightMargin={rightMargin}>
        <span className="message">{`${compileTemplateNew(selectedPromotion?.message || '', {
          SOURCE_AMOUNT: hvtThresholdLimit?.thresholdLimit,
          SOURCE_CURRENCY: sourceCurrency
        })} `}</span>
        <a href={selectedPromotion?.redirectUrl} rel="noreferrer" target="_blank">
          {selectedPromotion?.linkMessage}
        </a>
      </MessageContainer>
    </>
  );
};
